import React from 'react';
import './css/button.css'; // Assuming you have a CSS file for styling

export const Button = ({ children, onClick, variant, disabled = false, ...rest }) => {
    let buttonClass = `cw_button ${variant === undefined ? "blue" : variant}`;
    if (variant === "modal-close") {
        buttonClass = "close-button"
    }

    return (
        <button className={buttonClass} onClick={onClick} disabled={disabled} {...rest} >
            <span>{children}</span>
        </button>
    );
};